import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { getModels, getModel } from "."

export const getPeriod = state => get(state, "modules.researchTopicRoot.period")
const getRootSelectedDate = state => get(state, "modules.researchTopicRoot.selectedDate")
export const getResearchTopicDate = state => get(state, "global.data.topic.data.resource.selectedDate")

export const getSelectedDate = createSelector(
  [getRootSelectedDate, getModels, getModel],
  (rootDate, models, selectedModel) => {
    const modelLatestDate = chain(models).find(elem => elem.id === selectedModel).get("availability.currentDate").value()
    return rootDate || modelLatestDate
  },
)
